// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@ces/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalDisplayStyles } from "@ces/Overrides/Components/CartTotalDisplay";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    ...orderTotalDisplaySharedStyles.mainContainer,
};

cartTotalDisplayStyles.fullWidthGridItem = {
    width: 12,
};

cartTotalDisplayStyles.orderSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};
cartTotalDisplayStyles.promotionLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.otherChargesLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};

cartTotalDisplayStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};

cartTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};

cartTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

cartTotalDisplayStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};

cartTotalDisplayStyles.promotionValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.simpleNotifyGridtItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 8px;
            margin-bottom: 10px;
        }
    `,
};

cartTotalDisplayStyles.simpleNotify = {
    size: 12,
    lineHeight: "15px",
    weight: fontConfig.weight.regular,
    color: "common.ui",
};
